import { render, staticRenderFns } from "./HeadingImageProduct.vue?vue&type=template&id=232a57a3&"
import script from "./HeadingImageProduct.vue?vue&type=script&lang=js&"
export * from "./HeadingImageProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports